import buildShipToPartyInfo from './buildShipToPartyInfo';

const buildModifyOrderPayload = ({
  orderId,
  shipment,
  shipToPartyOperation = null,
  products = [],
}) => ({
  order_id: orderId,
  order_products: [],
  order_products_delivery: [
    {
      ship_to_party_info: buildShipToPartyInfo(
        shipment,
        shipToPartyOperation
      ),
      products_info: products,
    },
  ],
});

export default buildModifyOrderPayload;
